import { render } from "./ReaderView.vue?vue&type=template&id=438cb88e&scoped=true"
import script from "./ReaderView.vue?vue&type=script&lang=js"
export * from "./ReaderView.vue?vue&type=script&lang=js"

import "./ReaderView.vue?vue&type=style&index=0&id=438cb88e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438cb88e"]])

export default __exports__